import { render } from "./ContratoPublico.vue?vue&type=template&id=dba17ebe&scoped=true"
import script from "./ContratoPublico.vue?vue&type=script&lang=js"
export * from "./ContratoPublico.vue?vue&type=script&lang=js"

import "./ContratoPublico.vue?vue&type=style&index=0&id=dba17ebe&scoped=true&lang=css"

import exportComponent from "/home/runner/work/jeanInformatico-management-system/jeanInformatico-management-system/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dba17ebe"]])

export default __exports__